export default __webpack_public_path__ + "static/fa-light-300-82a7f6c93f80ab7559be536faa57c9fd.eot";